import React from "react"
import axios from "axios"
import { SidebarMenuItem } from "./SidebarMenuItem"
import { useAuth } from "../../../../../app/modules/auth"
import MyTooltip from "../../../../../app/utils/MyTooltip"
import {
     API_URL_ESPACE_CONSULTANT,
     CONST_CONSULTANT_CONTRAT_ST,
     CONST_USER_ROLE_CANDIDAT,
     CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE,
     CONST_USER_ROLE_CONSULTANT,
     CONST_USER_ROLE_RESPONSABLE_FOURNISSEUR,
} from "../../../../../app/constants"
import { SidebarMenuItemWithSub } from "./SidebarMenuItemWithSub"
import { TUTORIAL_TARGET_MENU_ITEM_PROFILE } from "../../../../../app/components/tutorial/targets/profile"
import { TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES } from "../../../../../app/components/tutorial/steps/activites"
import { CONST_CSE_NOTIFICATION_DISMISSED_KEY } from "../../../../../app/app-consultant/context/AppConsultantContext"

const SidebarMenuMain = () => {
     const { currentUser, infoPersoToBeFilled, documentsToBeFilled, infoFournisseurToBeFilled } = useAuth()

     // Feature flag: Show CSE only after 2025-12-16 13:12
     const showCseFeature = new Date() >= new Date("2026-01-01T00:00:00") && !currentUser?.fournisseur

     const handleCseClick = () => {
          // 1. Increment the counter in backend (Fire and forget)
          axios.post(`${API_URL_ESPACE_CONSULTANT}/seen-communication-tempeos`).catch(error => {
               console.error("Erreur lors de l'incrémentation du compteur CSE", error)
          })

          // 2. Save preference to LocalStorage so the popup doesn't show later
          localStorage.setItem(CONST_CSE_NOTIFICATION_DISMISSED_KEY, "true")
     }

     return (
          <>
               <SidebarMenuItem to="/mon-compte/profil" fontIcon={"fas fa-user"} title={"Mon profil"} iconClassName={TUTORIAL_TARGET_MENU_ITEM_PROFILE} />

               {/* Uniquement pour l'espace candidat & préembauche*/}
               {(currentUser?.user?.roles?.includes(CONST_USER_ROLE_CANDIDAT) || currentUser?.user?.roles?.includes(CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE)) && (
                    <>
                         <SidebarMenuItem to="/offres" fontIcon={"fas fa-briefcase"} title={"Offres"} />
                         <SidebarMenuItem to="/mes-candidatures" fontIcon={"fas fa-paper-plane"} title={"Mes candidatures"} />
                    </>
               )}

               {!currentUser?.user?.roles?.includes(CONST_USER_ROLE_RESPONSABLE_FOURNISSEUR) && (
                    <SidebarMenuItem to="/mes-docos" fontIcon={"fas fa-layer-group"} title={"Mes Dossiers de Compétences"} />
               )}

               {(currentUser?.user?.roles?.includes(CONST_USER_ROLE_CONSULTANT) || currentUser?.user?.roles?.includes(CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE)) && (
                    <SidebarMenuItem to="mon-compte/mes-documents" fontIcon={"fas fa-folder-tree"} title={"Mes documents"} />
               )}

               {currentUser?.user?.roles?.includes(CONST_USER_ROLE_CANDIDAT_EN_COURS_EMBAUCHE) && (
                    <>
                         <span>
                              <SidebarMenuItem
                                   to="/info-a-completer"
                                   icon={
                                        infoPersoToBeFilled.length > 0 ||
                                        documentsToBeFilled.length > 0 ||
                                        (currentUser?.fournisseur?.fournisseur && infoFournisseurToBeFilled.length > 0)
                                             ? "/media/icons/duotune/general/gen044.svg"
                                             : "/media/icons/duotune/general/gen043.svg"
                                   }
                                   title={"Dossier de recrutement"}
                                   iconColor={
                                        infoPersoToBeFilled.length > 0 ||
                                        documentsToBeFilled.length > 0 ||
                                        (currentUser?.fournisseur?.fournisseur && infoFournisseurToBeFilled.length > 0)
                                             ? "text-warning"
                                             : "text-success"
                                   }
                              />
                         </span>
                    </>
               )}

               {currentUser?.user?.roles?.includes(CONST_USER_ROLE_CONSULTANT) && (
                    <>
                         <SidebarMenuItemWithSub title={"Mes activités"} to={"#"} fontIcon={"fas fa-calendar-days"} iconClassName={TUTORIAL_TARGET_MENU_ITEM_MES_ACTIVITES}>
                              <SidebarMenuItem to={`/activites/declarations`} title={"Déclarations mensuelles"} fontIcon={"fas fa-list-check"} />

                              {currentUser?.consultant?.consultant?.contrat != CONST_CONSULTANT_CONTRAT_ST && (
                                   <>
                                        <MyTooltip title={"Mes Demandes De Congés"} placement={"right"}>
                                             <span>
                                                  <SidebarMenuItem to="activites/ddc" fontIcon={"fas fa-umbrella-beach"} title={"Mes DDC"} />
                                             </span>
                                        </MyTooltip>

                                        <MyTooltip title={"Maladie"} placement={"right"}>
                                             <span>
                                                  <SidebarMenuItem to="activites/maladie" fontIcon={"fas fa-file-medical"} title={"Mes arrêts maladie"} />
                                             </span>
                                        </MyTooltip>
                                   </>
                              )}

                              <MyTooltip title={"Mes Notes de Frais"} placement={"right"}>
                                   <span>
                                        <SidebarMenuItem to="activites/ndf" fontIcon={"fas fa-file-invoice-dollar"} title={"Notes de Frais"} />
                                   </span>
                              </MyTooltip>
                         </SidebarMenuItemWithSub>

                         {/* CSE Menu Item with tracking logic */}
                         {showCseFeature && (
                              <SidebarMenuItem
                                   to={`https://app.tempeos.com/login`}
                                   title={"CE Tempeos"}
                                   fontIcon="fas fa-gift"
                                   target={"_blank"}
                                   onClickCallback={handleCseClick}
                              />
                         )}
                    </>
               )}

               {currentUser?.user?.roles?.includes(CONST_USER_ROLE_RESPONSABLE_FOURNISSEUR) && (
                    <>
                         <SidebarMenuItem to="/espace-resp-fournisseur/collaborateurs" fontIcon={"fas fa-user-astronaut"} title={"Collaborateurs"} />
                         <SidebarMenuItem to="/espace-resp-fournisseur/declarations/voyants" fontIcon={"fas fa-calendar-days"} title={"Déclarations"} />
                    </>
               )}
          </>
     )
}

export { SidebarMenuMain }
